export type TExpirationDate = {
  month?: number | undefined;
  year?: number | undefined;
  hasError: boolean;
};

export type TFormField = {
  value: string;
  hasError: boolean;
};

export type TFieldName = 'invoiceNumber' | 'lastFourDigits' | 'expirationDate';

export type TFormState = {
  invoiceNumber: TFormField;
  lastFourDigits: TFormField;
  expirationDate: TExpirationDate;
};

export const getInitialState = () => ({
  invoiceNumber: { value: '', hasError: false },
  lastFourDigits: { value: '', hasError: false },
  expirationDate: {
    month: undefined,
    year: undefined,
    hasError: false,
  },
});

export type TFormActions =
  | {
      type: 'invoiceNumber';
      value: string;
    }
  | {
      type: 'lastFourDigits';
      value: string;
    }
  | {
      type: 'expirationDate';
      value: Partial<TExpirationDate>;
    }
  | {
      type: 'fieldError';
      value: {
        fieldName: TFieldName;
        hasError: boolean;
      };
    }
  | {
      type: 'clearAllFields';
      value: TFormState | undefined;
    };

export function formStateReducer(
  state: TFormState,
  action: TFormActions,
): TFormState {
  switch (action.type) {
    case 'expirationDate':
      const expDateNewState = state;
      expDateNewState.expirationDate.month = action.value.month;
      expDateNewState.expirationDate.year = action.value.year;
      return {
        ...state,
        ...expDateNewState,
      };

    case 'invoiceNumber':
      const invNumNewState = state;
      invNumNewState.invoiceNumber.value = action.value;
      return {
        ...state,
        ...invNumNewState,
      };

    case 'fieldError':
      const newState = state;
      newState[action.value.fieldName].hasError = action.value.hasError;
      return {
        ...state,
        ...newState,
      };

    case 'lastFourDigits':
      const digitsNewState = state;
      digitsNewState.lastFourDigits.value = action.value;
      return {
        ...state,
        ...digitsNewState,
      };
    case 'clearAllFields':
      state = getInitialState();
      return state;

    default:
      throw new Error();
  }
}
